import { getStudentAvatarByUrl, resolveProfileAvatarUrl } from '../data/studentProfileAvatars';
import { getStudentLevelDetails, LEVEL_SHIELDS } from './studentLevelProgress';

/**
 * @param {{ avatarUrl?: string | null } | null | undefined} profile
 * @returns {string | null}
 */
export function getLearnerAvatarUrl(profile) {
  return resolveProfileAvatarUrl(profile?.avatarUrl);
}

/**
 * Shield fallback when no custom avatar is set.
 * @param {{ completed?: number; total?: number; pct?: number } | null | undefined} progressSummary
 * @param {boolean} [showEnglish]
 */
export function getLearnerShieldSrc(progressSummary, showEnglish = true) {
  const details = getStudentLevelDetails(progressSummary ?? { completed: 0, total: 0, pct: 0 }, showEnglish);
  return LEVEL_SHIELDS[details.level];
}

/**
 * @param {{ avatarUrl?: string | null } | null | undefined} profile
 * @param {{ completed?: number; total?: number; pct?: number } | null | undefined} [progressSummary]
 * @param {boolean} [showEnglish]
 * @returns {{ type: 'avatar' | 'shield'; src: string; alt: string }}
 */
export function resolveLearnerPortrait(profile, progressSummary, showEnglish = true) {
  const avatarUrl = getLearnerAvatarUrl(profile);
  const avatar = getStudentAvatarByUrl(avatarUrl);
  if (avatarUrl && avatar) {
    return {
      type: 'avatar',
      src: avatarUrl,
      alt: showEnglish ? avatar.labelEn : avatar.labelHi,
    };
  }
  return {
    type: 'shield',
    src: getLearnerShieldSrc(progressSummary, showEnglish),
    alt: showEnglish ? 'Learner shield' : 'शिक्षार्थी ढाल',
  };
}
